import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Spinner,
} from "@chakra-ui/react";
import PenIcon from "../icons/PenIcon";

export type SimpleModalProps = {
  title?: string;
  icon?: React.ReactNode;
  colorScheme?: string;
  onClick?: () => void;
  onAbort?: () => void;
  onPaste?: (event: React.ClipboardEvent) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  w?: string;
  isUpdate?: boolean;
  hideButtons?: boolean;
  header?: boolean;
  acceptText?: string;
  abortText?: string;
  isPending?: boolean;
};

const SimpleModal = ({
  children,
  isOpen,
  onClose,
  onClick,
  onPaste,
  onAbort,
  onKeyDown,
  title,
  icon,
  colorScheme = "brand",
  w,
  isUpdate = false,
  hideButtons = false,
  header = true,
  acceptText,
  abortText,
  isPending = false,
}: ModalProps & SimpleModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
      <ModalContent
        maxW={"none"}
        w={w ?? "600px"}
        onPaste={(event) => {
          if (onPaste) {
            event.preventDefault();
            onPaste(event);
          }
        }}
        onKeyDown={(event) => {
          if ((event.ctrlKey || event.metaKey) && event.key === "v") {
            return;
          }
          if (onKeyDown) {
            event.preventDefault();
            onKeyDown(event);
          }
        }}
      >
        {header && (
          <ModalHeader borderBottom="solid 1px #E2E8F0">
            <Flex>
              <Flex
                w="48px"
                h="48px"
                bg="zinc.50"
                border="solid 1px"
                borderColor={`${colorScheme}.100`}
                justifyContent="center"
                alignItems="center"
                borderRadius={100}
                mr="8px"
              >
                {icon !== undefined && icon}
                {icon === undefined && (
                  <PenIcon w="24px" h="24px" color="brand.700"></PenIcon>
                )}
              </Flex>
              <Box lineHeight="48px">{title}</Box>
            </Flex>
          </ModalHeader>
        )}
        <ModalCloseButton onClick={onClose} />
        <ModalBody my={4}>{children}</ModalBody>
        {!hideButtons && (
          <ModalFooter borderTop="solid 1px #E2E8F0">
            <Flex w="100%" gap={4}>
              <Button
                w="100%"
                variant="link"
                onClick={onAbort ? onAbort : onClose}
                tabIndex={-1}
              >
                {abortText === undefined && "Annuler"}
                {abortText !== undefined && abortText}
              </Button>
              <Button
                w="100%"
                colorScheme={colorScheme}
                onClick={() => onClick && onClick()}
                disabled={isPending}
                className="items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                }}
              >
                {isPending && <Spinner size="sm" color="white" />}
                {acceptText !== undefined
                  ? acceptText
                  : !isUpdate
                  ? "Ajouter"
                  : "Enregistrer"}
              </Button>
            </Flex>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default SimpleModal;
